export const getErrorMessage = (error: any): string => {
  let message = "An unexpected error occurred";

  // 1. Network error (Axios generic)
  if (error?.message === "Network Error") {
    return "Network error! Please check your internet connection and try again.";
  }

  // 2. Low-level system/network failures (your case)
  if (typeof error?.message === "string") {
    const msg = error.message.toLowerCase();

    if (msg.includes("enetunreach")) {
      return "Network unreachable. Please check your connection or try again later.";
    }

    if (msg.includes("econnrefused")) {
      return "Connection refused. The server may be down.";
    }

    if (msg.includes("etimedout")) {
      return "Request timed out. Please try again.";
    }

    if (msg.includes("ehostunreach")) {
      return "Host unreachable. Please check your network.";
    }
  }

  // 3. Axios response error (HTTP response exists)
  if (error?.response?.data) {
    const data = error.response.data;

    if (Array.isArray(data.errors) && data.errors.length > 0) {
      message = data.errors[0].message || message;
    } else if (typeof data.message === "string") {
      message = data.message;
    } else if (error.response.statusText) {
      message = error.response.statusText;
    }
  }

  // 4. fallback
  else if (error?.message) {
    message = error.message;
  }

  return message;
};
